import React, { useEffect, useState } from "react";
import "./App.css";
import "./app/assets/css/style.css";
import RouteController from "./app/routes/RouteController";
import { useDispatch } from "react-redux";
import { getFingerprint } from "./app/redux/slices/fingerprintSlice";
import { getAuth } from "./app/redux/slices/authSlice";
import { getUser, getUserEmail } from "./app/libs/user";
import {
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  setAFCustomerUserId,
  setClevertapProfile,
  setMixpanelProfile,
  setUtmData,
} from "./app/libs/events";
import { fetchRemoteConfig } from "./app/services/remoteConfig";
import { getParameterFromURL, isMobileDevice } from "./app/libs/utils";
import { appConfig } from "./app/redux/slices/appSlice";

function App() {
  const dispatch = useDispatch();
  const [init, setInit] = useState(false);

  useEffect(() => {
    dispatch(getFingerprint());
    dispatch(getAuth());
  }, [dispatch]);

  useEffect(() => {
    setInit(true);
    if (init === true) {
      if (process.env.REACT_APP_ENV === "production") {
        window.console.log = function () {};
      }

      setUtmData();
      getUser()
        .then((response) => {
          setAFCustomerUserId(response.user.id);
        })
        .catch((error) => {});

      setClevertapProfile({ email: getUserEmail() });
      setMixpanelProfile({
        email: getUserEmail(),
        utm_source: getUtmSource(),
        utm_medium: getUtmMedium(),
        utm_campaign: getUtmCampaign(),
      });
    }
  }, [init]);

  useEffect(() => {
    dispatch(appConfig({ isMobileDevice: isMobileDevice() }));
    const banktype = getParameterFromURL("banktype");
    if (banktype) {
      sessionStorage.setItem("banktype", banktype);
    }

    fetchRemoteConfig()
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return <RouteController />;
}

export default App;
